import { MediaUpload } from '@wordpress/block-editor';
import { SelectControl, Button, RangeControl } from '@wordpress/components';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
} = wp;

const PlayIcon = ({ playBtn, setAttributes }) => {
  return (
    <>
      <span className="title-label">Play Icon</span>
      <MediaUpload
        onSelect={(file) => {
          setAttributes({
            playBtn: {
              ...playBtn,
              id: file.id,
              title: file.title,
              filename: file.filename,
              playButtonImgUrl: file.url,
              fileType: file.type,
            },
          });
        }}
        type="image"
        allowedTypes={['image']}
        value={playBtn.playButtonImgUrl}
        render={({ open }) => (
          <div className="media-upload image-upload">
            {playBtn.playButtonImgUrl && (
              <div className="upload-buttons-wrapper">
                <MediaReplaceButton onClick={open} />
                <MediaRemoveButton
                  onClick={() => {
                    setAttributes({
                      playBtn: {
                        ...playBtn,
                        playButtonImgUrl: '',
                      },
                    });
                  }}
                />
              </div>
            )}
            {!playBtn.playButtonImgUrl && (
              <Button className="media-button upload-button" onClick={open}>
                {__('Upload Image', 'b3rg')}
              </Button>
            )}
            {playBtn.playButtonImgUrl && (
              <div
                className="image-thumb-wrapper"
                onClick={open}
                onKeyUp={open}
                role="button"
                tabIndex="0"
              >
                <img
                  className="image-thumb"
                  src={playBtn.playButtonImgUrl}
                  alt=""
                />
              </div>
            )}
          </div>
        )}
      ></MediaUpload>
      <br />
      <span className="title-label">Play Button Size Unit</span>
      <SelectControl
        value={playBtn.playBtnUnit}
        options={[
          { label: 'Pixels', value: 'px' },
          { label: 'Percentage', value: '%' },
        ]}
        onChange={(newValue) => {
          setAttributes({
            playBtn: {
              ...playBtn,
              playBtnUnit: newValue,
            },
          });
        }}
      />
      <span className="title-label">Play Button Width</span>
      <RangeControl
        value={playBtn.playButtonWidth}
        onChange={(value) => {
          setAttributes({
            playBtn: {
              ...playBtn,
              playButtonWidth: value,
            },
          });
        }}
        min={10}
        max={1000}
      />
      <span className="title-label">Play Button Height</span>
      <RangeControl
        value={playBtn.playButtonHeight}
        onChange={(value) => {
          setAttributes({
            playBtn: {
              ...playBtn,
              playButtonHeight: value,
            },
          });
        }}
        min={10}
        max={1000}
      />
    </>
  );
};
export default PlayIcon;
